const companyNameModel = {
    id: "companyName",
    fields: {
        companyName: "companyName",
        currentPlaceID: "currentPlaceID",
        currentCityId: "currentCityId",
        cityName: "cityName",
        referralCode: "referralCode",
        serviceType: "serviceType"
    }
};

export { companyNameModel };
//# sourceMappingURL=companyNameModel.js.map
